export const titleWrapper = {
  padding: '15px 15px 0px 15px',
}

const titleBase = {
  margin: '0',
  textAlign: 'left',
}

export const title = {
  ...titleBase,
  color: 'rgb(49, 71, 128)',
}

export const titleSecondary = {
  ...titleBase,
  color: 'white',
}
